import { useTranslation } from 'react-i18next';

import { Namespace, Path } from 'enums';
import { UserPermissions } from 'store';

import { CompensationPage } from './CompensationPage';

export const MyCompensationPage = () => {
  const { t } = useTranslation(Namespace.PersonalArea);

  return (
    <CompensationPage
      breadcrumbs={{
        mainBreadcrumbLink: `/${Path.Home}`,
        mainBreadcrumbTitle: t('myRequests'),
      }}
      permissions={UserPermissions.BasePermissions}
      isAccountPage
    />
  );
};
